import HeaderImg from '../../../assets/images/enno-engagement-header.png'
import { HeaderProps } from '../../../types/props'

const Header = ({ image, style }: HeaderProps) => {
  return (
    <div className='engagement__header d-flex justify-content-center'>
      <img src={image ?? HeaderImg} alt='header' style={style} />
    </div>
  )
}

export default Header
